export class ExportHelpers {
  static toJson = (filename: string, jsonString: string) => {
    const a = document.createElement('a');
    const file = new Blob([jsonString], { type: 'text/plain' });
    a.href = window.URL.createObjectURL(file);
    a.download = `${filename}.json`;
    a.click();
  };

  static toCsv = (filename: string, rows: (string | number | null | undefined)[][], separator = ',') => {
    const escapeCell = (cell: string | number | null | undefined): string => `"${String(cell ?? '').replace(/"/g, '""')}"`;
    const content = rows.map((row) => row.map(escapeCell).join(separator)).join('\r\n');
    const a = document.createElement('a');
    // BOM prefix so Excel renders UTF-8 accents correctly.
    const file = new Blob([`\uFEFF${content}`], { type: 'text/csv;charset=utf-8;' });
    a.href = window.URL.createObjectURL(file);
    a.download = `${filename}.csv`;
    a.click();
  };
}
